<ion-grid class="ion-no-padding">
  <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
    <ion-row class="ion-justify-content-center">
      <ion-col
        size="12"
        size-md="10"
        size-lg="8"
        class="ion-no-margin ion-no-padding"
      >
        <ion-row class="ion-align-items-center ion-padding-top">
          <ion-col size="12" size-lg="4" class="ion-hide-down">
            <ion-label class="align-label">{{
              'password_current' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="12" size-lg="8">
            <ion-input
              type="password"
              fill="outline"
              formControlName="existingpassword"
              [label]="'password_current' | translate"
              label-placement="stacked"
              [class.is-invalid]="
                formHelper.isFieldValidCss(
                  'existingpassword',
                  formSubmitAttempted()
                )
              "
            >
              <ion-input-password-toggle slot="end"></ion-input-password-toggle>
            </ion-input>
          </ion-col>
        </ion-row>

        <ion-row class="ion-align-items-center">
          <ion-col size="12" size-lg="4" class="ion-hide-down">
            <ion-label class="align-label">{{
              'password_new' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="12" size-lg="8">
            <ion-input
              type="password"
              fill="outline"
              formControlName="newpassword"
              [label]="'password_new' | translate"
              label-placement="stacked"
              [class.is-invalid]="
                formHelper.isFieldValidCss('newpassword', formSubmitAttempted())
              "
            >
              <ion-input-password-toggle slot="end"></ion-input-password-toggle>
            </ion-input>
          </ion-col>
        </ion-row>

        <ion-row class="ion-align-items-center">
          <ion-col size="12" size-lg="4" class="ion-hide-down">
            <ion-label class="align-label">{{
              'password_confirm' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="12" size-lg="8">
            <ion-input
              type="password"
              fill="outline"
              formControlName="confirmpassword"
              [label]="'password_confirm' | translate"
              label-placement="stacked"
              [class.is-invalid]="
                formHelper.isFieldValidCss(
                  'confirmpassword',
                  formSubmitAttempted()
                )
              "
            >
              <ion-input-password-toggle slot="end"></ion-input-password-toggle>
            </ion-input>
          </ion-col>
        </ion-row>

        <ion-row class="ion-margin-top">
          <ion-col size="12" offset-lg="4">
            <ion-button
              type="submit"
              color="primary"
              [disabled]="passwordForm.invalid"
              expand="block"
            >
              <small>{{ 'general_update' | translate }}</small>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </form>
</ion-grid>
